function B1() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        Б1 Операційне управління закладом дошкільної освіти
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="5">
                        Б1.1 Здатність ефективно здійснювати фінансово-господарську діяльність закладу дошкільної освіти
                    </td>
                    <td>
                        Б1.1.31 Нормативно-правова база організації фінансово-господарської діяльності закладу
                        дошкільної освіти
                    </td>
                    <td>
                        Б1.1.У1 Організовувати фінансово-господарську діяльність закладу дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Б 1.1.32 Основи бухгалтерського обліку закладу дошкільної освіти
                    </td>
                    <td>
                        Б1.1.У2 Організовувати бухгалтерський облік закладу дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.1.33 Матеріально-технічна база закладу дошкільної освіти
                    </td>
                    <td>
                        Б1.1.УЗ Зберігати, зміцнювати та раціонально використовувати матеріально-технічну базу закладу
                        дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.1.34 Вимоги до термінів і форм оприлюднення результатів фінансово-господарської діяльності
                    </td>
                    <td>
                        Б1.1.У4 Оприлюднювати результати фінансово-господарської діяльності
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.1.35 Основи фандрейзингу та краудфандингу
                    </td>
                    <td>
                        Б1.1.У5 Використовувати інструменти фандрейзингу та краудфандингу для залучення матеріальних та
                        нематеріальних ресурсів
                    </td>
                </tr>
                <tr>
                    <td rowSpan="3">
                        Б1.2 Здатність до організації та контролю харчування у закладі дошкільної освіти
                    </td>
                    <td>
                        Б1.2.31 Нормативно-правова база організації та контролю харчування у закладі дошкільної освіти
                    </td>
                    <td>
                        Б1.2.У1 Здійснювати організацію та контроль за якістю харчування у закладі дошкільної освіти
                        відповідно до законодавства та з урахуванням постійно діючих процедур Системи
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.2.32 Норми харчування у закладі дошкільної освіти
                    </td>
                    <td>
                        Б1.2.У2 Здійснювати організацію харчування в закладі дошкільної освіти з урахуванням принципів
                        здорового харчування та національних культурних традицій
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.2.33 Порядок організації харчування у закладі дошкільної освіти
                    </td>
                    <td>
                        Б1.2.УЗ Планувати та організовувати харчування у закладі освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.3 Здатність до організації та контролю медичного обслуговування у закладі дошкільної освіти
                    </td>
                    <td>
                        Б1.3.31 Нормативно-правова база організації та контролю медичного обслуговування у закладі
                        дошкільної освіти
                    </td>
                    <td>
                        Б1.3.У1 Організовувати та здійснювати контроль за медичним обслуговуванням у закладі дошкільної
                        освіти
                    </td>
                </tr>
                <tr>
                    <td rowSpan="6">
                        Б1.4 Здатність до управління персоналом та командної взаємодії
                    </td>
                    <td>
                        Б1.4.31 Нормативно-правова база з організації трудових відносин
                    </td>
                    <td>
                        Б1.4.У1 Здійснювати адміністративно-кадрове регулювання трудових відносин.
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.4.32 Основи управління персоналом
                    </td>
                    <td>
                        Б1.4.У2 Використовувати сучасні методи та інструменти управління персоналом
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.4.З3 Сутність та функції організаційної культури закладу дошкільної освіти
                    </td>
                    <td>
                        Б1.4.У3 Здійснювати підбір, навчання та управління персоналом через систему спільних цінностей,
                        поглядів та ставлень
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.4.З4 Засади командної взаємодії під час управлінської діяльності
                    </td>
                    <td>
                        Б1.4.У4 Застосовувати принципи командної взаємодії в управлінській діяльності
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.4.35 Принципи та засади делегування повноважень
                    </td>
                    <td>
                        Б1.4.У5 Делегувати повноваження та керівництво закладом дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Б1.4.36 Нормативно-правові засади підвищення кваліфікації та професійного розвитку педагогічних
                        працівників
                    </td>
                    <td>
                        Б1.4.У6 Створювати умови для безперервного професійного розвитку персоналу
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {B1}